/* import __COLOCATED_TEMPLATE__ from './sh-navbar-dropdown.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'sh-dropdown';
const CONTENT_CLASS_NAME = `${CLASS_NAME}__content`;
const SITE_NAV_CONTENT_CLASS_NAME = `${CONTENT_CLASS_NAME}--site-nav`;
const PROFILE_BUTTON_CLASS_NAME = `${CONTENT_CLASS_NAME}--profile-button`;

class ShNavbarDropdownComponent extends Component {
  get classNames() {
    const buttonType = this.args.buttonType;

    return clsx(
      CLASS_NAME,
      this.args.class,
      'dropdown-trigger',
      buttonType ? `btn-${buttonType}` : 'btn',
    );
  }

  get contentClassNames() {
    return clsx(
      CONTENT_CLASS_NAME,
      SITE_NAV_CONTENT_CLASS_NAME,
      this.args.isProfileButton && PROFILE_BUTTON_CLASS_NAME,
    );
  }

  get alignment() {
    return this.args.alignment ?? 'left';
  }

  @action
  closeOnClick(dropdown) {
    dropdown.actions.close();
  }
}

export default ShNavbarDropdownComponent;
